import icon from "../../../../assets/images/leftMenu/base/cx_gaphic.png"
export default {
  name: "图文列表",
  id: "",
  thumbnail: icon,
  type: "cxGaphic",
  typeId: "",
  children: [],
  sort: 1,
  enable: params => params.admin
}
